import React, { useEffect } from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@material-ui/core';
import infoStepsJson from '../../data/Landing.json';
import useStyles from './useStyles';
import { WhatsappButton } from '../WhatsappButton';

export const FooterInfoImages = () => {
  const {
    FooterImages: {
      title,
      body,
      buttonTitle,
    },
  } = infoStepsJson;
  const classes = useStyles();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box component="section" className={classes.container}>
      <Box className={classes.innerContainer}>
        <Box
          className={clsx(classes.item, classes.itemBackground)}
        >
          <Box className={clsx(
            classes.innerItem,
            classes.marginContainer,
            classes.displayFlexbox,
          )}
          >
            <Typography variant="h2" component="h2" className={classes.title}>{title}</Typography>
            <Typography variant="body1" component="p" className={classes.body}>{body}</Typography>
            <Box className={classes.containerButton}>
              <WhatsappButton>{buttonTitle}</WhatsappButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
